import * as React from 'react'
import {
  WrappedFieldProps,
  Field,
  GenericField,
  BaseFieldProps
} from 'redux-form'
import { Checkbox } from 'react-bootstrap'
import ControlWrapper from './ControlWrapper'

export interface CheckboxControlCustomProps {
  label: string
  type?: string
}

export type CheckboxControlProps = WrappedFieldProps &
  CheckboxControlCustomProps

const CheckboxControl: React.SFC<CheckboxControlProps> = props => {
  const { input, label, meta } = props

  return (
    <ControlWrapper meta={meta}>
      <Checkbox data-test={input.name} {...input}>{label}</Checkbox>
    </ControlWrapper>
  )
}

const CustomField = Field as new () => GenericField<CheckboxControlCustomProps>

export type CheckboxControlFieldProps = BaseFieldProps<
  CheckboxControlCustomProps
> &
  CheckboxControlCustomProps

export const CheckboxControlField: React.SFC<
  CheckboxControlFieldProps
> = props => (
  <CustomField type="checkbox" {...props} component={CheckboxControl} />
)

export default CheckboxControl



// WEBPACK FOOTER //
// ./src/components/form/CheckboxControl.tsx